import React, { useEffect } from 'react';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../config/firebase';

const LegalPopup = ({ isOpen, onClose, title, content }) => {
  // ESC key to close and prevent body scroll
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      // Track legal popup views
      logEvent(analytics, "legal_page_view", {
        page_title: title,
      });

      document.addEventListener("keydown", handleEsc);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto";
    };
  }, [isOpen, onClose, title]);

  if (!isOpen) return null;

  return (
    <div className="legal-popup-backdrop" onClick={onClose}>
      <div
        className="legal-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="legal-popup-card">
          <h2 className="legal-popup-title">{title}</h2>
          <div className="legal-popup-divider"></div>
          <div className="legal-popup-content">{content}</div>
        </div>
      </div>
    </div>
  );
};

export default LegalPopup;
